export enum TopupStatus {
    PENDING='PENDING',
    NEW='NEW',
    PROCESSED='PROCESSED',
    SUCCESS='SUCCESS'
}